var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunderBlueVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color-anim",
    d: "M14.967 9.41016H10.6143L11.9248 1.28341C12.112 0.122444 10.5675 -0.458038 9.86547 0.435011L0.224081 12.8037C-0.337554 13.5182 0.224081 14.5898 1.16014 14.5898H5.5128L4.15552 22.7166C3.96831 23.8776 5.5128 24.458 6.21485 23.565L15.8562 11.1963C16.4647 10.4372 15.903 9.41016 14.967 9.41016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderBlueVector);
export default __webpack_public_path__ + "static/media/thunder_blue_vector.c37f17a492a2c3b836b3826daa97bcab.svg";
export { ForwardRef as ReactComponent };